/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import UserService from "../../services/userService";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] });
const cacheLtr = createCache({ key: 'ltr' });

const UserDropdown = ({ helperText, error, setFormValues, isFilter, selectedUser, setSelectedUser }) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const [users, setUsers] = useState([]);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const data = await UserService.fetchAll();
                setUsers(data);
            } catch (error) {
                console.error('Error fetching pages:', error);
            }
        };
        fetchUsers();
    }, []);

    return (
        <CacheProvider value={i18n.language === 'en' ? cacheLtr : cacheRtl}>
            <Autocomplete
                options={users}
                getOptionLabel={(option) => option.name || ""}
                value={selectedUser}
                onChange={(event, newValue) => {
                    setSelectedUser(newValue);
                    setFormValues && setFormValues((prevValues) => ({
                        ...prevValues,
                        userId: newValue ? newValue.id : null,
                    }));
                }}
                renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                        {option.name}
                    </li>
                )}
                renderInput={(params) => (
                    <Box>
                        {
                            !isFilter && <p
                                style={{
                                    color: theme.palette.text.primary,
                                    fontSize: 13,
                                    marginTop: 24,
                                    marginBottom: 4,
                                }}
                            >
                                {t("user")}
                            </p>
                        }

                        <TextField
                            {...params}
                            variant={isFilter ? 'standard' : 'outlined'}
                            fullWidth
                            placeholder={isFilter ? t('user') : t('chooseUser')}
                            error={!!error}
                            helperText={helperText}
                            InputProps={{
                                ...params.InputProps,
                                ...(isFilter ? { disableUnderline: true } : {}),
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                                style: {
                                    backgroundColor: isFilter ? 'transparent' : theme.palette.customGrey.insideInput,
                                    padding: '6px 8px',
                                },
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: theme.palette.customGrey.borderInput,
                                    },
                                    '&:hover fieldset': {
                                        borderColor: theme.palette.customGrey.borderInput,
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: theme.palette.primary.main,
                                    },
                                },
                                '& .MuiInputBase-input': {
                                    color: theme.palette.text.primary,
                                    padding: '6px 8px',
                                    '&::placeholder': {
                                        fontSize: '14px',
                                        color: theme.palette.text.secondary,
                                        opacity: 1,
                                    },
                                },
                            }}
                        />
                    </Box>
                )}
            />
        </CacheProvider>
    );
}

export default UserDropdown;